import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { identity } from "./auth-service-tools248.js";

function polymorphicFactory(ui) {
  const Component = /*#__PURE__*/forwardRef(ui);

  Component.withProps = fixedProps => {
    const Extended = /*#__PURE__*/forwardRef((props, ref) => /* @__PURE__ */jsxRuntimeExports.jsx(Component, { ...fixedProps,
      ...props,
      ref
    }));
    Extended.extend = Component.extend;
    Extended.displayName = `WithProps(${Component.displayName})`;
    return Extended;
  };

  Component.extend = identity;
  return Component;
}

export { polymorphicFactory };